import {
  PressEvent,
  ToggleButton as RACToggleButton,
} from "react-aria-components";
import { toggleButton } from "./toggleButton.css";
import { ReactNode } from "react";

interface IToggleButton {
  id: string;
  /** Used to render text or icon elements in the button */
  children: ReactNode;
  /** Provides an accessible label for screen readers. Required when the button contains only an icon. */
  ariaLabel?: string;
  /** Whether the button is selected (controlled) */
  isSelected?: boolean;
  /** Whether the button is selected (uncontrolled) */
  defaultSelected?: boolean;
  /** Handler that is called when the press is released over the target.*/
  onClick?: (e: PressEvent) => void;
  isDisabled?: boolean;
}

const ToggleButton = ({
  id,
  children,
  ariaLabel,
  isSelected,
  defaultSelected,
  onClick,
  isDisabled = false,
}: IToggleButton) => {
  return (
    <RACToggleButton
      id={id}
      className={toggleButton}
      isSelected={isSelected}
      onPress={onClick}
      isDisabled={isDisabled}
      aria-label={ariaLabel}
      defaultSelected={defaultSelected}
    >
      {children}
    </RACToggleButton>
  );
};

export default ToggleButton;
